export default "/images/vendor/flag-icon-css/flags/4x3/sk.svg?be58e557507f1468968917cb825153ab";